export default function Curriculum({ Modules }: { Modules: any }) {
  return (
    <section className="space-y-8 px-4 mt-4">
      <ol className="border-l border-[#9A7026] border-dotted">
        {Modules &&
          Modules.length > 0 &&
          Modules.map((session: any, index: number) => (
            <li
              className="mb-4 ml-[-6px] bg-transparent flex -left-1.5 space-x-2"
              key={session.id}
            >
              <div className="flex items-center">
                <div className="w-3 h-3 bg-[#9A7026] text-start rounded-full" />
              </div>
              <div className="flex flex-col w-full bg-white p-4 rounded-md">
                <span className=" text-base md:text-xl text-left w-full font-semibold text-black">
                  {session.title}
                </span>
                <span className="text-sm md:text-base mt-2 text-[#666666]">
                  {session.description}
                </span>
              </div>
            </li>
          ))}
      </ol>

      {(Modules?.length === 0 || !Modules) && (
        <p className="font-medium">Curriculum will be updated soon</p>
      )}
    </section>
  );
}
